class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.custom-slider__list');
    this.sliderItems = this.querySelectorAll('.custom-slider__item');
    this.currentPage = 1;
    
    this.prevButton = this.querySelector('.custom-slider__button--prev');
    this.nextButton = this.querySelector('.custom-slider__button--next');
    this.currentPageElement = this.querySelector('.custom-slider__current');
    this.totalPages = this.sliderItems.length;

    if (!this.slider || !this.sliderItems.length) return;

    this.initButtons();
    this.updateButtonsState();
  }

  initButtons() {
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const isNext = event.currentTarget.name === 'next';
    const slideScrollPosition = isNext
      ? this.slider.scrollLeft + this.slider.clientWidth
      : this.slider.scrollLeft - this.slider.clientWidth;

    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });

    // Update current page
    this.currentPage = isNext 
      ? Math.min(this.currentPage + 1, this.sliderItems.length)
      : Math.max(this.currentPage - 1, 1);

    this.updateButtonsState();
    this.updateCounter();
  }

  updateButtonsState() {
    if (!this.prevButton || !this.nextButton) return;

    this.prevButton.disabled = this.currentPage === 1;
    this.nextButton.disabled = this.currentPage === this.sliderItems.length;
  }

  updateCounter() {
    if (this.currentPageElement) {
      this.currentPageElement.textContent = this.currentPage;
    }
  }
}

customElements.define('custom-slider', CustomSlider); 